/**
 * External dependencies
 */
import $ from "jquery";

/*
 * Internal dependencies
 */
import "./modules/product-search-modal";
import "./polyfills/object-fit";
import "./modules/slider";
import "./modules/aos";
import "./modules/nav";
import "./modules/scroll-header";
import "./modules/accordion";
import "./modules/quantity";
import "./modules/steps";
import "./modules/filters";
import "./modules/load-more";
import "./modules/maps";
import "./modules/search";
import "./modules/magnific-popup";
import "./modules/add-to-cart";
import "./modules/cart-item";
// import "./modules/equal-height";
import "./modules/hide-label";
import "./modules/read-more";

import { initChatra } from "./modules/chatra.js";

initChatra();
